module.exports = __webpack_public_path__ + "media/images/admin/node_builder_img/brands_logo/lxt-394f09c352a5a3257f0dda39e05d2416.svg";